import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { DanceChange, DanceModel } from "./DancePanel";
const DancePanel = lazy(() => import("./DancePanel").then((module) => ({ default: module.DancePanel })));

export interface DancePanelMount {
  model: DanceModel;
  busy: boolean;
  onChange: (change: DanceChange) => Promise<void>;
}

/** The Dance tab on the storyboard step; a production without dance shots clears the slot. */
export function mountDancePanel(projectId: string, props: DancePanelMount | null) {
  if (!props) return clearStudioView("dance-panel");
  setStudioView("dance-panel", `dance-panel:${projectId}`, <DancePanel {...props} />);
}
